import { newElement, slideUp, slideDown } from '../utils/drawing';

/**
 * Insights and resources articles controls.
 */
export default function articlesSection() {

  const axios = require('axios').create({
    headers: {
        'X-CSRF-Token': window.csrfToken
    }
  });

  const articleSection = document.querySelector('div[data-section-handle]') ? document.querySelector('div[data-section-handle]').getAttribute('data-section-handle') : false;
  if (!articleSection) return;

  const filterButtonsContainer = document.querySelector('.insights_filters_buttons');
  if (!filterButtonsContainer) return;
  
  const resultsContainer = document.querySelector('.insights_results');
  const cardContainer = resultsContainer.querySelector('.body_cards > .container > .grid');

  const filterButtons = filterButtonsContainer.querySelectorAll('button.button');
  const optionsButtons = document.querySelectorAll('.insights_filters_drop-down button');

  const clearFiltersButton = filterButtonsContainer.querySelector('button.insights_filters_buttons-remove');
  const loadMoreButton = document.getElementById('insights-load-more-button');
  const loadMoreButtonMessage = loadMoreButton.innerHTML;
  
  let page = 1, limit = 12;
  let cardTemplate = null, cardAttributes = null, selectedGroup = null;
  let selectedOptions = [];

  // Setup sub arrays for filters
  filterButtons.forEach(button => {
    selectedOptions.push([]);
  });

  const defaultResultsLimit = parseInt(loadMoreButton.dataset.defaultLimit) || 8;
  let resultsLimit = defaultResultsLimit;

  // Expand options drop downs
  const toggleOptions = group => {

    selectedGroup = (selectedGroup !== group) ? group : null;

    document.querySelectorAll(`.insights_filters_drop-down`).forEach(dropdown => {
      if (dropdown.dataset.filterName !== group) slideDown(dropdown, 80, () => {
        dropdown.classList.replace('-is-open', '-is-closed');
      });
    });

    let target = document.querySelector(`.insights_filters_drop-down[data-filter-name="${group}"]`);
    if (target) {
      
      if (target.classList.contains('-is-open')) {

        slideDown(target, 160, () => {
          target.classList.replace('-is-open', '-is-closed');
        });
      } else {

        slideUp(target, 160, () => {
          target.classList.replace('-is-closed', '-is-open');
        });
      }
    }
  }

  // Redraw insights articles
  const reRender = insights => {

    // Get the card template
    if (!cardTemplate) {
      const firstCard = cardContainer.querySelector('.card');

      if (firstCard) {  
        cardTemplate = firstCard.parentNode.innerHTML;
        cardAttributes = firstCard.attributes;
      }
    }

    // Render result
    cardContainer.innerHTML = '';
    if (insights.data.length < 1) {

      // No results
      let result = newElement('div', {}, '<div class="card no-resilts"><h2>No articles found.</h2></div>');
      cardContainer.appendChild(result);

      // Hide load more button
      loadMoreButton.parentNode.classList.add('+hidden');
    } else {

      // Show results (to limit)
      insights.data.slice(0, resultsLimit).forEach(insight => {
        let card = newElement('div', cardAttributes, cardTemplate);
        
        card.querySelector('.card_content_meta').innerHTML = insight.type;

        // need to strip any source information
        let imageBlock = card.querySelector('.card_content_thumbnail picture');
        if (imageBlock) {
          let imageBlockImg = imageBlock.querySelector('img')
          let imageBlockSource = imageBlock.querySelector('source');
          if (imageBlockSource) imageBlockSource.remove();
          if (imageBlockImg) imageBlockImg.removeAttribute('srcset');
          if (insight.image) {
            imageBlockImg.src = insight.image;
          } else {
            imageBlockImg.remove();
          }
        }
        card.querySelector('.card_content_title a.h4').href = insight.url;
        card.querySelector('.card_content_title a.h4').innerHTML = insight.title;
        cardContainer.appendChild(card);
        card.addEventListener('click', event => {
          document.location.href = insight.url;
        });
      });

      // Reset and show/hide load mode button
      loadMoreButton.innerHTML = loadMoreButtonMessage;
      if (insights.data.length > resultsLimit) {
        loadMoreButton.parentNode.classList.remove('+hidden');
      } else {
        loadMoreButton.parentNode.classList.add('+hidden');
      }
    }

    // Loaded
    resultsContainer.classList.replace('-loading', '-loaded');
  }

  // Fetch insights articles
  async function updateInsights(filter, showLoading = true) {

    // Clear any empty arrays from filter value
    filter.value = filter.value.filter(value => {
      return value.length > 0;
    });

    // Check header items (show/hide clear button)
    clearFiltersButton.classList[filter.value.length > 0 ? 'remove' : 'add']('+hidden');
    
    // Loading indicator/s
    if (showLoading) {
      loadMoreButton.parentNode.classList.add('+hidden');
      resultsContainer.classList.replace('-loaded', '-loading');
    }

    // Fetch insights articles
    await axios.post(
      '?p=actions/tesserent/articles/fetch',
      { 
        CSRF_TOKEN: window.csrfToken,
        section: articleSection,
        filters: Object.assign(filter, {
          limit: resultsLimit, page: page
        }),
      }
    )
    .then(function (response) {
      reRender(response);
    })
    .catch(function (error) {
      console.log(error);
    });
  }

  // Filter group buttons
  const clickFilterButton = event => {

    let group = event.target.dataset.filterName;
    filterButtons.forEach(b => b.classList.remove('-selected'));

    if (group !== selectedGroup) event.target.classList.add('-selected');
    toggleOptions(group);
  }
  filterButtons.forEach(button => button.addEventListener('click', clickFilterButton));

  // Option buttons
  optionsButtons.forEach(button => {
    button.addEventListener('click', event => {

      let group = button.parentNode.dataset.filterName;
      let index = parseInt(button.parentNode.dataset.filterIndex);
      let value = button.dataset.filterValue;
      let filterButton = document.querySelector(`button[data-filter-name="${group}"]`);

      if (selectedOptions[index].includes(value)) {

        // Remove from selectedOptions
        const vi = selectedOptions[index].indexOf(value);
        if (vi > -1) selectedOptions[index].splice(vi, 1);
        button.classList.remove('-selected');

        // If there are no selected options in this group then unset hilite on group button
        let hasSelections = false;
        let options = button.parentNode.querySelectorAll('button');
        options.forEach(b => {
          if (b.classList.contains('-selected')) hasSelections = true;
        });
        if (hasSelections) {
          if (filterButton) filterButton.classList.add('-has-selections');
        } else {
          if (filterButton) filterButton.classList.remove('-has-selections');
        }
      } else {

        // Add to selectedOptions
        selectedOptions[index].push(value);
        button.classList.add('-selected');

        // Add hilite to selected group button
        if (filterButton) filterButton.classList.add('-has-selections');
      }

      // Always reset results limit
      resultsLimit = defaultResultsLimit;

      // Update results
      updateInsights({
        label: group,
        value: selectedOptions
      })
    });
  });

  // Load more button
  loadMoreButton.addEventListener('click', event => {

    // Increase limit and update
    loadMoreButton.innerHTML = 'Loading...';
    resultsLimit = resultsLimit + defaultResultsLimit;

    updateInsights({
      label: null,
      value: selectedOptions
    }, false);
  });

  // Clear all button
  clearFiltersButton.addEventListener('click', event => {

    // Clear filter selection classes
    filterButtons.forEach(button => {
      button.classList.remove('-selected');
      button.classList.remove('-has-selections');
    });

    // Close all option dropdowns
    toggleOptions(null);

    // Clear option selection classes
    optionsButtons.forEach(button => {
      button.classList.remove('-selected');
    });

    // Always reset results limit
    resultsLimit = defaultResultsLimit;

    // Clear filter values and update
    selectedOptions = selectedOptions.map(value => {
      return [];
    });
    updateInsights({
      label: null,
      value: selectedOptions
    });
  });
}


// WEBPACK FOOTER //
// ./source/scripts/sections/insights.js